import { SVG, SVGProps } from './svg'

export function IconAdd(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M19 11.5v1c0 .3-.2.5-.5.5H13v5.5c0 .3-.2.5-.5.5h-1a.5.5 0 01-.5-.5V13H5.5a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5H11V5.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5V11h5.5c.3 0 .5.2.5.5z" />
    </SVG>
  )
}
